import { createReducer, on, Action } from '@ngrx/store';
import * as menuActions from './menu.actions';
import { MenuItem } from '@service/app-toolbar/app-toolbar.service';

export interface ReducerMenuState {
  items: MenuItem[],
  adminUrls: MenuItem[],
  institutionUrls: MenuItem[],
  isSuperuser: boolean,
  isInstitutionAdmin: boolean,
}

export const initialState: ReducerMenuState = {
  items: [],
  adminUrls: [],
  institutionUrls: [],
  isSuperuser: false,
  isInstitutionAdmin: false,
};

const menuReducerInternal = createReducer(
  initialState,
  on(menuActions.addMenuItem, (state, { payload }) => ({
    ...state,
    items: state.items.map(item => item.title).includes(payload.title) ? [...state.items] : [...state.items, payload]
  })),
  on(menuActions.addAdminUrlMenuItem, (state, { payload }) => ({
    ...state,
    adminUrls: state.adminUrls.map(item => item.title).includes(payload.title) ? [...state.adminUrls] : [...state.adminUrls, payload]
  })),
  on(menuActions.addInstitutionUrlMenuItem, (state, { payload }) => ({
    ...state,
    institutionUrls: state.institutionUrls.map(item => item.title).includes(payload.title) ? [...state.institutionUrls] : [...state.institutionUrls, payload]
  })),
  on(menuActions.updateMenuItem, (state, { payload }) => {
    const index = state.items.findIndex(x => x.title === payload.title);

    state.items[index] = payload;

    return {
      ...state
    };
  }),
  on(menuActions.clearMenu, state => ({
    ...state,
    items: []
  })),
  on(menuActions.clearAdminUrlsMenu, state => ({
    ...state,
    adminUrls: []
  })),
  on(menuActions.clearInstitutionUrlsMenu, state => ({
    ...state,
    institutionsUrls: []
  })),
  on(menuActions.setIsSuperUser, state => ({
    ...state,
    isSuperuser: true
  })),
  on(menuActions.setIsInstitution, state => ({
    ...state,
    isInstitutionAdmin: true
  })),
);

export function menuReducer(
  state: ReducerMenuState | undefined,
  action: Action
) {
  return menuReducerInternal(state, action);
};
